<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import Cookies from "js-cookie"
export default {
  name: 'App',
  mounted () {
    // window.addEventListener("beforeunload", (e) => this.beforeunloadHandler(e));
    // window.addEventListener("unload", (e) => this.unloadHandler(e));
  },
  destroyed () {
    // window.removeEventListener("beforeunload", (e) =>
    //   this.beforeunloadHandler(e)
    // );
    window.removeEventListener("unload", (e) => this.unloadHandler(e));
  },
  methods: {
    // 页面关闭之前，触发提示框
    beforeunloadHandler (e) {
      if (e) {
        e = e || window.event;
        console.log(e);
        if (e) {
          e.returnValue = "关闭提示";
        }
        return "关闭提示";
      }
    },
    // 页面关闭
    unloadHandler (e) {
      // 退出登录
      this.logout();

    },
    logout () {
      sessionStorage.removeItem("user")
      localStorage.removeItem('loginInfo');
      localStorage.removeItem('menuList')
      this.deleteCookie("token")
      this.$router.push("/login")
      this.$api.login.logout({}).then((res) => {
      }).catch(function (res) {
      })

    },
    // 删除cookie
    deleteCookie: function (name) {
      Cookies.remove(name)
    },
  }
}
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #484a4d;
  /* background:  #b6bbbb21; */
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  /* background-image: url('https://moairresource.n2do.info/newSite/home/banner-001.jpg');
  background-size: 100% 100%; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue